import { useIntl } from "react-intl";
import { CourseMaterial } from "./coursesLoader";

export function useRequiredCode({
  requiredCode,
}: Pick<CourseMaterial, "requiredCode">): string | null {
  const intl = useIntl();
  if (!requiredCode) {
    return null;
  } else if (requiredCode === "required") {
    return intl.formatMessage({ defaultMessage: "Required" });
  } else if (requiredCode === "recommended") {
    return intl.formatMessage({ defaultMessage: "Recommended" });
  } else if (requiredCode === "optional") {
    return intl.formatMessage({ defaultMessage: "Optional" });
  } else {
    return requiredCode;
  }
}
